import AdditionalQuestionsCompletedContainer from './additional_questions_completed_container';

const AdditionalQuestionsCompleted = AdditionalQuestionsCompletedContainer;
export default AdditionalQuestionsCompleted;
